import { appendDisplayMagnitudePostfix } from '@lib/util/display-magnitude';
import { Field } from '@ui/components/Field';
import { DollarSignIcon } from '@ui/components/Icons';
import { selectQuoteBuilder } from '@ui/features/quote-builder/state/selectors/quote-builder';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuotePriceContext } from './QuotePriceProvider';

export function UnitCost() {
  const displayQuantity = useSelector(
    (state) => selectQuoteBuilder(state).displayQuantity,
  );
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();
  const { value } = useSelector((state) =>
    selectQuotePriceField(state, quoteLineUuid, quotePriceUuid, 'unitCost'),
  );

  return (
    <Field
      label={appendDisplayMagnitudePostfix('Unit Cost', displayQuantity, '/')}
      showLabel={isFirstQuotePrice}
      leftIcon={DollarSignIcon}
      value={value}
      type="number"
      isDisabled
    />
  );
}
